import { render, staticRenderFns } from "./identityAuth.vue?vue&type=template&id=3313a3f0&scoped=true"
import script from "./identityAuth.vue?vue&type=script&lang=js"
export * from "./identityAuth.vue?vue&type=script&lang=js"
import style0 from "./identityAuth.vue?vue&type=style&index=0&id=3313a3f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3313a3f0",
  null
  
)

export default component.exports